import React from 'react';
import Modal from 'react-bootstrap/Modal';

function CommentsModal({ show, onHide, comments }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="comments-modal"
      className="comments-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="comments-modal">
          Comments
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
          {comments || 'No comments available'}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default CommentsModal;

